import { render } from "./bill-center.vue?vue&type=template&id=08c7fa6c&scoped=true&ts=true"
import script from "./bill-center.vue?vue&type=script&lang=ts"
export * from "./bill-center.vue?vue&type=script&lang=ts"

import "./bill-center.vue?vue&type=style&index=0&id=08c7fa6c&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c7fa6c"]])

export default __exports__